<template>
	<div class="ArrowRightMoreIcon svgIcon" :style="{ width: size + 'px', height: size + 'px' }">
		<svg t="1691986216330" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="24627" :width="size" :height="size">
			<path
				d="M731.733333 480l-384-341.333333c-17.066667-14.933333-44.8-14.933333-59.733333 4.266666-14.933333 17.066667-14.933333 44.8 4.266667 59.733334L640 512 292.266667 821.333333c-17.066667 14.933333-19.2 42.666667-4.266667 59.733334 8.533333 8.533333 19.2 14.933333 32 14.933333 10.666667 0 19.2-4.266667 27.733333-10.666667l384-341.333333c8.533333-8.533333 14.933333-19.2 14.933334-32s-4.266667-23.466667-14.933334-32z"
				fill="#0076f6"
				p-id="24628"
			></path>
		</svg>
	</div>
</template>
<script setup name="ArrowRightMoreIcon">
	let props = defineProps({
		size: {
			type: [Number,String],
			default: () => 16
		}
	})
</script>
<style scoped lang="less">
	.ArrowRightMoreIcon,
	.svgIcon {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
